import Api from '@/services/Api'

export default {
	getContratoCuotaByNumContr(nroContract){
		return Api().get('contratoCuotas/getContratoCuotaByNumContrato/'+nroContract)
	},
	createContratoCuota(datos){
		return Api().post('contratoCuotas/create',datos)
	},
	modificacionContractual(fechaProceso,userId) {
		return Api().get('contratoCuotas/modificacionContractual'+'/'+fechaProceso+'/'+userId)
	},
}
